<template>
  <div class="max-w-md">
    <img
      v-if="src"
      :src="src"
      :alt="alt"
      width="110"
      class="success-image mb-2 block mx-auto md:inline md:mx-0"
    >
    <BaseParagraph class="text-grey mb-4">
      <slot />
    </BaseParagraph>
    <slot name="button" />
  </div>
</template>

<script>
import BaseParagraph from './BaseParagraph.vue';

export default {
  name: 'BaseEmptyState',
  components: {
    BaseParagraph,
  },
  props: {
    src: {
      type: String,
      default: null,
    },
    alt: {
      type: String,
      default: 'Empty state',
    },
  },
};
</script>
